import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import ClearIcon from "@material-ui/icons/Clear";
import { withStyles } from "@material-ui/core/styles";
import Help from "./Help";
import ReportBugForm from "./ReportBugForm";

const styles = () => ({
  drawerPaper: {
    zIndex: 1200,
    width: "260px"
  }
});

class RightSidebar extends React.Component {
  state = {
    content: undefined
  };

  componentDidMount() {
    this.setState({
      content: this.getContent()
    });
  }

  componentDidUpdate = prevProps => {
    if (prevProps.context !== this.props.context || prevProps.content !== this.props.content) {
      this.setState({
        content: this.getContent()
      });
    }
  };

  getContent = () => {
    switch (this.props.content) {
      case "help":
        return <Help context={this.props.context} />;
      case "bug":
        return <ReportBugForm />;
      default:
        return undefined;
    }
  };

  render() {
    const { classes, content, toggleRightSidebar } = this.props;

    return (
      <Drawer
        classes={{ paper: classes.drawerPaper }}
        variant={this.props.isMobile ? "" : "persistent"}
        anchor="right"
        open={content ? true : content}
      >
        <div>
          <IconButton color="primary" onClick={toggleRightSidebar}>
            <ClearIcon />
          </IconButton>
        </div>
        <div>{this.state.content}</div>
      </Drawer>
    );
  }
}

export default withStyles(styles)(RightSidebar);
